import { LastMessageText } from '@halo/ui-chat-react';
import { Flex, Text } from '@chakra-ui/react';
import { useMsgMediaTitle } from '../msg-media-call';
import type { MsgMediaCallTimeoutContentProps } from './msg-media-call-timeout-content';
import { MsgMediaCallTimeoutContent } from './msg-media-call-timeout-content';

export interface MsgMediaCallTimeoutPreviewProps extends MsgMediaCallTimeoutContentProps {}

export const MsgMediaCallTimeoutPreview = memo(function MsgMediaCallTimeoutPreview({
  message,
}: MsgMediaCallTimeoutPreviewProps) {
  const { type } = message.payload;

  const { title } = useMsgMediaTitle({ type });

  return (
    <LastMessageText>
      <Flex alignItems="center">
        <Text as="span" color="fg.error">
          {title}
        </Text>
        <MsgMediaCallTimeoutContent message={message} />
      </Flex>
    </LastMessageText>
  );
});
